import React from 'react'

const Footer = (props) => {

    return (
        <div className='footer'>
            <p>© 2024 Younglimwon Team Platform All Rights Reserved.</p>
            <a
                href="https://www.ksystem.co.kr/privacy-statement/"
                target="_blank"
            >
                개인정보처리방침
            </a>
        </div>
    )
}

export default Footer;